import products from "../data/all-products/all-products";

export const ProductsAction = (dispatch) => {
  try {
    dispatch({ type: "PRODUCT_LIST_REQUEST" });
    dispatch({
      type: "PRODUCT_LIST_SUCCESS",
      payload: products,
    });
  } catch (error) {
    console.log(error);
  }
};

export const ProductAction = (id) => (dispatch) => {
  try {
    dispatch({ type: "PRODUCT_REQUEST" });
    dispatch({
      type: "PRODUCT_SUCCESS",
      payload: products.find((item) => item.id === id),
    });
  } catch (error) {
    console.log(error);
  }
};
